module.exports = __webpack_public_path__ + "img/zjyg1.a08a5a5c.jpg";